import React from "react";
import { DeploymentRTSPJobTable } from "./deployment-rtsp-job-table/DeploymentRTSPJobTable";

/**
 * This component renders a table of Deployment RTSP Jobs.
 *
 * @example
 * import { DeploymentRTSPJobsCard } from "./DeploymentRTSPJobsCard";
 *
 * <DeploymentRTSPJobsCard />
 */
export function DeploymentRTSPJobsCard() {
  return (<DeploymentRTSPJobTable />);
}
